import React from 'react';
import { menuData } from '../data/menu';

const Menu = () => {
  return (
    <div className="w-full bg-stone-50 min-h-screen pt-24 pb-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">Menu Kami</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Nikmati berbagai pilihan hidangan lezat yang kami sajikan dengan penuh cinta, mulai dari masakan Nusantara hingga Western.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {menuData.map((category, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-sm">
              <h2 className="text-2xl font-serif font-bold text-emerald-800 mb-6 border-b border-emerald-100 pb-4">
                {category.category}
              </h2>
              <div className="space-y-6">
                {category.items.map((item, idx) => (
                  <div key={idx} className="flex justify-between items-start group">
                    <div className="pr-4">
                      <h3 className="font-bold text-gray-800 text-lg group-hover:text-emerald-600 transition-colors">
                        {item.name}
                      </h3>
                      {item.description && (
                        <p className="text-gray-500 text-sm mt-1">{item.description}</p>
                      )}
                    </div>
                    <div className="shrink-0">
                      <span className="font-bold text-emerald-600">Rp {item.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu;
